import React from 'react';
import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
}
export function Reveal({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: RevealProps) {
  const prefersReducedMotion = useReducedMotion();
  const MotionTag = motion[as];
  if (prefersReducedMotion) {
    const Tag = as;
    return <Tag className={className} data-id="element-786" data-mp="2js9e955vv6dc">{children}</Tag>;
  }
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-64px'
  }} transition={{
    duration: 0.4,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-787" data-mp="2nr9z0t7x8j2z">
      {children}
    </MotionTag>;
}